<template>
  <div>
    <el-tooltip
      v-if="toolTip"
      class="item"
      effect="dark"
      :content="toolTip"
      :open-delay="1500"
      placement="bottom">
      <div class="description-label">{{ label }}</div>
    </el-tooltip>
    <div v-else class="description-label">{{ label }}</div>
    <div class="description-content">{{ content }}</div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    content: {
      type: [String, Number],
      default: ''
    },
    toolTip: {
      type: String,
      default: ''
    }

  }
}
</script>
<style scoped>
.description-label {
  font-size: 12px;
  font-weight: 400;
  color: #9ca3af;
  line-height: 17px;
  display: inline;
}
.description-content {
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  line-height: 20px;
  margin-top: 3px;
}
</style>
